const KEY_PREFIX = 'marck.lastFolder.';

export function getLastFolder(clientId: number): string | null {
  try {
    return localStorage.getItem(`${KEY_PREFIX}${clientId}`);
  } catch {
    return null;
  }
}

export function setLastFolder(clientId: number, path: string): void {
  try {
    localStorage.setItem(`${KEY_PREFIX}${clientId}`, path);
  } catch {
    // localStorage may be unavailable (private mode, quota); ignore
  }
}
